// src/utils/directMessaging.js

/**
 * Normalizes phone number for WhatsApp and SMS:
 * e.g., '+91 98765-43210' -> '919876543210'
 */
export const formatPhoneNumberForDirect = (phone) => {
    if (!phone) return '';
    let clean = phone.replace(/[^\d+]/g, '');
    if (clean.startsWith('+')) {
        clean = clean.substring(1);
    }
    // If 10 digit Indian number without country code, add 91
    if (clean.length === 10) {
        clean = '91' + clean;
    }
    return clean;
};

/**
 * Opens WhatsApp directly via Browser (WhatsApp Web/Desktop) or Native Mobile App.
 * Does NOT require Twilio, Meta Cloud API, or backend credentials.
 */
export const sendDirectWhatsApp = (phone, message) => {
    const cleanPhone = formatPhoneNumberForDirect(phone);
    if (!cleanPhone) {
        throw new Error('Invalid phone number for WhatsApp.');
    }
    const encodedText = encodeURIComponent(message || '');
    // Using api.whatsapp.com/send works seamlessly across:
    // 1) Desktop Chrome/Edge/Firefox/Safari (routes to WhatsApp Web or Desktop App)
    // 2) Mobile Chrome/Safari (deep-links to WhatsApp App)
    // 3) Capacitor / Android / iOS WebViews (opens WhatsApp App)
    const url = `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encodedText}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    return true;
};

/**
 * Opens the native SMS app directly on Mobile or Desktop.
 * Does NOT require Twilio or SMS gateway fees.
 */
export const sendDirectSMS = (phone, message) => {
    const cleanPhone = formatPhoneNumberForDirect(phone);
    if (!cleanPhone) {
        throw new Error('Invalid phone number for SMS.');
    }
    const encodedText = encodeURIComponent(message || '');
    
    // Cross-platform SMS URL scheme:
    // iOS Safari uses &body=
    // Android, Windows, macOS, Linux use ?body=
    const isIOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const smsUri = isIOS 
        ? `sms:${cleanPhone}&body=${encodedText}`
        : `sms:${cleanPhone}?body=${encodedText}`;
        
    window.location.href = smsUri;
    return true;
};
